module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Fc-Ga-Hc-Ib-Ja.7b2ad5fc.png";